/* ASSAF order limit – products tagged ASF_LIMIT.tag are capped at ASF_LIMIT.max per order
   (per product, all variants combined). Reads the tag directly; no collection needed. */
(() => {
  const C = window.ASF_LIMIT;
  if (!C) return;
  const MAX = C.max;
  const limitedVariants = C.variants || {};            // variantId -> productId (limited only)
  const knownVariants = new Set((C.known || []).map(String)); // variants already checked
  const checkedHandles = {};
  const nativeFetch = window.fetch.bind(window);
  const productOf = id => limitedVariants[String(id)];


  // ---- Popup (replaces the browser alert) ----
  const FLAG = 'asfLimitNotice';
  function injectStyles() {
    if (document.getElementById('asf-limit-style')) return;
    const css = `
      .asf-limit{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit}
      .asf-limit__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.45);opacity:0;transition:opacity .2s ease}
      .asf-limit__box{position:relative;width:100%;max-width:360px;background:#fff;color:#000;border-radius:14px;padding:28px 24px 22px;text-align:center;
        box-shadow:0 18px 50px rgba(0,0,0,.25);transform:translateY(12px);opacity:0;transition:transform .22s ease,opacity .22s ease}
      .asf-limit.is-open .asf-limit__backdrop{opacity:1}
      .asf-limit.is-open .asf-limit__box{transform:none;opacity:1}
      .asf-limit__badge{width:52px;height:52px;margin:0 auto 14px;border-radius:50%;border:1.5px solid #000;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:600;line-height:1}
      .asf-limit__title{margin:0 0 8px;font-size:18px;font-weight:600;line-height:1.35}
      .asf-limit__text{margin:0 0 20px;font-size:15px;line-height:1.55;color:#444}
      .asf-limit__btn{appearance:none;border:0;width:100%;min-height:46px;border-radius:999px;background:#000;color:#fff;font:inherit;font-size:15px;font-weight:600;cursor:pointer}
      .asf-limit__btn:focus-visible{outline:2px solid #000;outline-offset:3px}
      @media (prefers-reduced-motion:reduce){.asf-limit__backdrop,.asf-limit__box{transition:none}}`;
    const st = document.createElement('style');
    st.id = 'asf-limit-style';
    st.textContent = css;
    document.head.appendChild(st);
  }
  function showNotice() {
    if (document.querySelector('.asf-limit')) return;
    injectStyles();
    const wrap = document.createElement('div');
    wrap.className = 'asf-limit';
    wrap.dir = C.rtl ? 'rtl' : 'ltr';
    wrap.innerHTML = `
      <div class="asf-limit__backdrop"></div>
      <div class="asf-limit__box" role="alertdialog" aria-modal="true" aria-labelledby="asf-limit-title" aria-describedby="asf-limit-text">
        <div class="asf-limit__badge" aria-hidden="true">${MAX}</div>
        <h2 class="asf-limit__title" id="asf-limit-title"></h2>
        <p class="asf-limit__text" id="asf-limit-text"></p>
        <button type="button" class="asf-limit__btn"></button>
      </div>`;
    wrap.querySelector('.asf-limit__title').textContent = C.title;
    wrap.querySelector('.asf-limit__text').textContent = C.message;
    const btn = wrap.querySelector('.asf-limit__btn');
    btn.textContent = C.button;
    const prevFocus = document.activeElement;
    const close = () => {
      wrap.classList.remove('is-open');
      document.removeEventListener('keydown', onKey, true);
      setTimeout(() => wrap.remove(), 220);
      if (prevFocus && prevFocus.focus) prevFocus.focus();
    };
    const onKey = e => { if (e.key === 'Escape' || e.key === 'Tab') { e.preventDefault(); if (e.key === 'Escape') close(); else btn.focus(); } };
    btn.addEventListener('click', close);
    wrap.querySelector('.asf-limit__backdrop').addEventListener('click', close);
    document.addEventListener('keydown', onKey, true);
    document.body.appendChild(wrap);
    requestAnimationFrame(() => { wrap.classList.add('is-open'); btn.focus(); });
  }
  // Show after a reload if the cart was trimmed on the previous page.
  function showPendingNotice() {
    try { if (sessionStorage.getItem(FLAG)) { sessionStorage.removeItem(FLAG); showNotice(); } } catch (e) {}
  }

  const getCart = () => nativeFetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  // Look up a product's tags once (by handle) and remember all its variants.
  async function checkHandle(handle) {
    if (checkedHandles[handle]) return checkedHandles[handle];
    checkedHandles[handle] = nativeFetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(p => {
        if (!p) return;
        const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        const limited = tags.map(t => t.trim().toLowerCase()).includes(C.tag.toLowerCase());
        p.variants.forEach(v => {
          knownVariants.add(String(v.id));
          if (limited) limitedVariants[String(v.id)] = p.id;
        });
      })
      .catch(() => {});
    return checkedHandles[handle];
  }

  const totals = cart => cart.items.reduce((m, i) => {
    if (productOf(i.variant_id)) m[i.product_id] = (m[i.product_id] || 0) + i.quantity;
    return m;
  }, {});

  // Error in Shopify's own shape, so the theme shows its normal "can't add" message.
  const blocked = () => new Response(
    JSON.stringify({ status: 422, message: 'Cart Error', description: C.message }),
    { status: 422, headers: { 'Content-Type': 'application/json' } }
  );

  async function clampItems(items) {
    const have = totals(await getCart());
    let cut = false;
    const out = [];
    for (const it of items) {
      const p = productOf(it.id);
      let q = parseInt(it.quantity || 1, 10);
      if (p) {
        const left = Math.max(0, MAX - (have[p] || 0));
        if (q > left) { q = left; cut = true; }
        have[p] = (have[p] || 0) + q;
      }
      if (q > 0) out.push({ ...it, quantity: q });
    }
    return { out, cut };
  }

  // Safety net: trims any line over the limit (quick-add, cart page edits, cart links, classic forms).
  let running = false;
  async function enforce() {
    if (running) return;
    running = true;
    try {
      let cart = await getCart();
      const unknown = cart.items.filter(i => !knownVariants.has(String(i.variant_id)));
      await Promise.all([...new Set(unknown.map(i => i.handle))].map(checkHandle));
      const used = {};
      let changed = false;
      for (const it of cart.items) {
        if (!productOf(it.variant_id)) continue;
        const allowed = Math.max(0, MAX - (used[it.product_id] || 0));
        if (it.quantity > allowed) {
          await nativeFetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.key, quantity: allowed })
          });
          changed = true;
        }
        used[it.product_id] = (used[it.product_id] || 0) + Math.min(it.quantity, allowed);
      }
      if (changed) { try { sessionStorage.setItem(FLAG, '1'); } catch (e) {} location.reload(); }
    } finally { running = false; }
  }

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

    if (isAdd && init.body) {
      if (init.body instanceof FormData) {
        const fd = init.body;
        if (productOf(fd.get('id'))) {
          const { out, cut } = await clampItems([{ id: fd.get('id'), quantity: fd.get('quantity') || 1 }]);
          if (!out.length) { showNotice(); return blocked(); }
          fd.set('quantity', out[0].quantity);
          if (cut) showNotice();
        }
      } else {
        let body = null;
        try { body = JSON.parse(init.body); } catch (e) {}
        if (body) {
          const items = body.items || [{ id: body.id, quantity: body.quantity }];
          const { out, cut } = await clampItems(items);
          if (!out.length) { showNotice(); return blocked(); }
          if (cut) showNotice();
          const next = body.items ? { ...body, items: out } : { ...body, quantity: out[0].quantity };
          init = { ...init, body: JSON.stringify(next) };
        }
      }
    }

    const res = await nativeFetch(input, init);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) enforce();
    return res;
  };

  if (C.current) {
    const capInputs = () => document.querySelectorAll('input[name="quantity"]').forEach(i => { i.max = MAX; });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', capInputs); else capInputs();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showPendingNotice); else showPendingNotice();
  enforce();
})();